// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"603d2f3b","206":"5be3ec47","973":"a5d71fdc"}[chunkId] + ".chunk.js";
};